/* Impression SCDM — LA PELLICULE EST INCLUSE SUR LES PANNEAUX DU REPERTOIRE.
   11 septembre 2026. Decision du proprietaire.

   ============================================================================
   POURQUOI
   ============================================================================
   Un panneau du Repertoire des dispositifs de signalisation routiere passe sa
   vie dehors : soleil, sel, souffleuse, lavage a pression. La pellicule de
   protection n est pas une option sur ce produit-la, c est ce qui fait qu il
   tient. Elle etait pourtant facultative, decochee d avance, et la plupart des
   clients partaient sans elle — verifie dans le code le 11 septembre : rien
   dans scdm-panneau.js ne la posait, et DEFAUTS.laminage vaut « aucun ».

   TROIS CONSEQUENCES, ET ELLES SONT TOUTES LES TROIS ICI OU JUSTE A COTE :

   1. LE COUT DE LA PELLICULE ENTRE DANS LE TARIF DE CES PANNEAUX. On ne
      recalcule rien : on coche la case a la place du client, et c est le
      calcul de scdm.js — le meme, exactement le meme — qui ajoute le tarif
      au pouce carre et le montage de la passe. Une seule verite de prix.

   2. LA RANGEE DU LAMINAGE DISPARAIT, POUR CES PANNEAUX-LA SEULEMENT. Elle
      reste entiere sur tout le reste du catalogue. Un choix qui n en est plus
      un ne doit pas etre offert : le client le decocherait et paierait le
      meme prix, ou ne le decocherait pas et se demanderait pourquoi.

   3. LE POIDS DE LA PELLICULE PART AVEC LE COLIS. Il ne l a jamais fait —
      0,0079 kg/pi2 nulle part dans le calcul d expedition. La correction est
      dans assets/scdm-panier-technique.js (POIDS.pellicule, poidsPellicule) :
      elle vaut pour TOUS les designs lamines, pas seulement les panneaux.

   ============================================================================
   COMMENT, ET POURQUOI C EST UN FICHIER A PART
   ============================================================================
   On ne touche NI a scdm.js NI a scdm-panneau.js. On pose etat.laminage,
   exactement comme un clic du client l aurait pose, et tout le reste du tuyau
   — prix affiche, bordereau, panier, poids du colis, epreuve — fonctionne sans
   savoir que ce n est pas le client qui a clique.

   EN CAPTURE, donc avant les ecouteurs de scdm.js poses sur les conteneurs :
   quand il calcule, la pellicule est deja posee. Et une veille periodique,
   parce que scdm.js reconstruit ses rangees a chaque redessin et rouvre celle
   du laminage des qu il repasse par la — meme raison et meme remede que
   scdm-lettrage-decoupe.js, qui referme la meme rangee sur du lettrage.

   ON REMET LES CHOSES EN PLACE EN PARTANT. Si c est NOUS qui avons coche la
   case, on la decoche quand le client quitte le panneau routier. S il l avait
   cochee lui-meme avant d arriver, on n y touche pas : son choix lui
   appartient.

   Charge depuis snippets/scdm-minimum.liquid, en defer, APRES scdm-panneau.js
   (qui pose window.SCDM_PANNEAU_ACTIF, lu par laminageOffert() de scdm.js).

   ATTENTION : sans ce fichier, la pellicule redevient facultative sur les
   panneaux du Repertoire et le prix baisse d autant. Rien d autre ne casse.
   ============================================================================ */

(function () {
  'use strict';

  /* Le laminage qu on pose. C est l identifiant de la ligne de LAMINAGES dans
     assets/scdm-data.js — le tarif, le montage et le libelle vivent la-bas, et
     seulement la-bas. Si la ligne changeait de nom, on retombe sur la premiere
     du tableau plutot que de ne rien poser. */
  var ID_PELLICULE = 'protection';

  /* Les panneaux du Repertoire, et eux seuls. Meme regle que estRoutier() de
     scdm-panneau.js : scdm-modeles.js depose « modele-scdm-<id>.<ext> » dans le
     champ de televersement, et les panneaux du Repertoire ont un identifiant
     qui commence par « mtq- ». On ne recode pas la detection, on la recopie a
     l identique — si elle change la-bas, elle doit changer ici aussi. */
  var PREFIXE_REPERTOIRE = 'mtq-';

  var VEILLE_MS = 150;

  var posePar = false;    /* c est NOUS qui avons coche la case ? */
  var mot = null;         /* la phrase qui remplace la rangee */

  function S() { return window.SCDM; }
  function D() { return window.SCDM_DATA; }
  function id(x) { return document.getElementById(x); }

  function argent(n) { return (Math.round(n * 100) / 100).toFixed(2).replace('.', ',') + ' $'; }

  function pellicule() {
    var l = (D() && D().LAMINAGES) || [];
    for (var i = 0; i < l.length; i++) if (l[i].id === ID_PELLICULE) return l[i];
    return l[0] || null;
  }

  function modeleCharge() {
    var e = S() && S().etat;
    var nom = (e && e.fichier && e.fichier.name) || '';
    var m = nom.match(/^modele-scdm-(.+)\.[A-Za-z0-9]+$/);
    return m ? m[1] : null;
  }

  function estPanneauRepertoire() {
    var i = modeleCharge();
    return !!(i && i.indexOf(PREFIXE_REPERTOIRE) === 0);
  }

  /* ------------------------------------------------------------ LA PELLICULE */

  function poser(estPanneau) {
    var e = S() && S().etat;
    var p = pellicule();
    if (!e || !p) return false;

    if (estPanneau) {
      if (e.laminage === p.id) return false;      /* deja la : rien a faire */
      e.laminage = p.id;
      posePar = true;
      return true;
    }
    /* On ne defait que ce qu on a fait. Un client qui avait coche la
       pellicule lui-meme sur un autre produit la garde. */
    if (posePar) {
      if (e.laminage === p.id) e.laminage = 'aucun';
      posePar = false;
      return true;
    }
    return false;
  }

  /* --------------------------------------------------------------- LA RANGEE */

  /* On ne la remontre jamais nous-memes : scdm.js repose fld.hidden a chaque
     redessin, selon laminageOffert(). Des qu on cesse de la cacher, elle
     revient toute seule — c est exactement ce qu on veut, et ca evite de se
     battre avec lui pour la propriete du meme noeud. */
  function rangee(estPanneau) {
    var r = id('scdmLaminages');
    if (!r) return;
    var fld = (r.closest && r.closest('.fld')) || r;
    if (estPanneau) {
      if (!fld.hidden) fld.hidden = true;
      if (fld.style.display !== 'none') fld.style.display = 'none';
    }
    phrase(fld, estPanneau);
  }

  /* LA PHRASE QUI REMPLACE LA RANGEE. Elle est a NOUS : personne d autre ne
     l ecrit, personne d autre ne l efface. Posee par insertion pure, juste
     apres la rangee cachee, donc a la place exacte ou le client s attendait a
     trouver le choix. */
  function phrase(fld, estPanneau) {
    if (!mot || !document.body.contains(mot)) {
      if (!estPanneau) return;
      if (!fld || !fld.parentNode) return;
      mot = document.createElement('p');
      mot.id = 'scdmPelliculeMot';
      mot.setAttribute('role', 'status');
      mot.style.cssText = 'margin:0 0 14px;padding:11px 13px;border-radius:9px;' +
        'border:1px solid currentColor;font-size:12.5px;line-height:1.55;opacity:.92';
      fld.parentNode.insertBefore(mot, fld.nextSibling);
    }
    mot.hidden = !estPanneau;
    if (!estPanneau) return;

    var p = pellicule();
    var h = '<b>Pellicule de protection incluse.</b> Un panneau de route passe ' +
      'ses journées au soleil, au sel et au lavage : la pellicule est comprise ' +
      'd’office dans le prix affiché, vous n’avez rien à cocher.';
    var f = p && Number(p.fixeCommande);
    if (f > 0) {
      h += ' Le montage de la passe de lamination — ' + argent(f) + ' — est compté ' +
           'une seule fois par commande, peu importe le nombre de panneaux.';
    }
    if (mot.innerHTML !== h) mot.innerHTML = h;
  }

  /* ------------------------------------------------------------- LA VEILLE */

  /* Un etat qui a bouge doit se voir. scdm.js ne publie pas sa fonction de
     rendu ; un evenement « input » sur le champ de largeur passe par SON
     ecouteur, qui relit la meme valeur et redessine tout. Aucun effet de bord,
     et le prix suit. Meme procede que rafraichir() de scdm-panneau.js. */
  function redessiner() {
    var el = id('scdmLargeur');
    if (el) el.dispatchEvent(new Event('input', { bubbles: true }));
  }

  function veiller() {
    if (!S() || !S().etat) return;
    var estPanneau = estPanneauRepertoire();
    var change = poser(estPanneau);
    rangee(estPanneau);
    if (change) redessiner();
  }

  function demarrer() {
    if (!id('scdmConfig')) return;

    /* EN CAPTURE : on passe avant les ecouteurs que scdm.js pose sur ses
       conteneurs, donc la pellicule est posee quand il calcule. */
    ['input', 'change', 'click'].forEach(function (ev) {
      document.addEventListener(ev, function () {
        try { poser(estPanneauRepertoire()); } catch (e) {}
        setTimeout(veiller, 0);
      }, true);
    });

    setInterval(veiller, VEILLE_MS);
    veiller();
  }

  function quandPret(n) {
    if (id('scdmConfig') && window.SCDM && window.SCDM.calcul && window.SCDM_DATA) {
      return demarrer();
    }
    if ((n || 0) > 200) return;
    setTimeout(function () { quandPret((n || 0) + 1); }, 120);
  }

  /* Pour le banc d essai hors ligne : la seule chose publiee, et elle est en
     lecture. Rien du site n en depend. */
  window.SCDM_PELLICULE_PANNEAU = {
    estPanneauRepertoire: estPanneauRepertoire,
    veiller: veiller
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { quandPret(0); });
  } else {
    quandPret(0);
  }
})();
